export var SelectedPreset;
(function (SelectedPreset) {
    SelectedPreset["DATE"] = "DATE";
    SelectedPreset["STORE"] = "STORE";
    SelectedPreset["SELLER"] = "SELLER";
    SelectedPreset["CAMPAIGN"] = "CAMPAIGN";
    SelectedPreset["STORE_LOCATION"] = "STORE_LOCATION";
    SelectedPreset["PROACTIVE_CONTACTS"] = "PROACTIVE_CONTACTS";
})(SelectedPreset || (SelectedPreset = {}));
export var SellerDayOffRelevantKeys;
(function (SellerDayOffRelevantKeys) {
    SellerDayOffRelevantKeys["SUGGESTION_DATE"] = "SUGGESTION_DATE";
    SellerDayOffRelevantKeys["SUGGESTION_DAY"] = "SUGGESTION_DAY";
    SellerDayOffRelevantKeys["SUGGESTION_WEEK"] = "SUGGESTION_WEEK";
    SellerDayOffRelevantKeys["SUGGESTION_MONTH"] = "SUGGESTION_MONTH";
    SellerDayOffRelevantKeys["SUGGESTION_YEAR"] = "SUGGESTION_YEAR";
    SellerDayOffRelevantKeys["AMOUNT_SELLER_DAY_OFF"] = "AMOUNT_SELLER_DAY_OFF";
})(SellerDayOffRelevantKeys || (SellerDayOffRelevantKeys = {}));
export const StoreSellerPresets = new Set([SelectedPreset.STORE, SelectedPreset.SELLER]);
export const DateDimensionKeys = new Set([
    SellerDayOffRelevantKeys.SUGGESTION_DATE,
    SellerDayOffRelevantKeys.SUGGESTION_DAY,
    SellerDayOffRelevantKeys.SUGGESTION_WEEK,
    SellerDayOffRelevantKeys.SUGGESTION_MONTH,
    SellerDayOffRelevantKeys.SUGGESTION_YEAR,
]);
